module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Field Template Create'
      }
    }
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn green margin-bottom-10"
  }, [_vm._v("\n      Add New\n    ")]) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.templates,
      "pagination-options": {
        'enabled': true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field === 'actions') ? [_c('div', {
          staticClass: "last-dropdown"
        }, [_c('actions-menu', [_c('actions-menu-item', {
          attrs: {
            "title": "Edit",
            "icon": "fa-edit",
            "to": {
              name: 'Field Template Edit',
              params: {
                id: props.row.id
              }
            }
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Remove",
            "icon": "fa-trash"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showDeletionModal(props.row)
            }
          }
        })], 1)], 1)] : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 3859376414)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n      No forms available.\n    ")])]) : _vm._e(), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "id": "delete-confirmation",
      "title": "DELETE TEMPLATE",
      "question": "Are you sure you would like to delete this template?"
    },
    on: {
      "confirmed": function($event) {
        return _vm.removeTemplate(_vm.templateToDelete)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d8bd5a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/indexes/FieldTemplatesIndex.vue
// module id = 1594
// module chunks = 1